import { render, staticRenderFns } from "./DraftPlans.vue?vue&type=template&id=33d2510a&"
import script from "./DraftPlans.vue?vue&type=script&lang=js&"
export * from "./DraftPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports